import React from 'react';
import { useHelp } from '../../contexts/HelpContext';
import { Lightbulb } from 'lucide-react';

export const HelpTip = ({ title, children, className = '' }) => {
    const { helpMode } = useHelp();

    // Als hulp modus uit staat, renderen we HELEMAAL NIETS.
    if (!helpMode) return null;

    return (
        <div className={`bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-indigo-500 p-4 rounded-r-xl shadow-sm my-4 animate-fadeIn ${className}`}>
            <div className="flex items-start gap-3">
                <div className="p-2 bg-white rounded-full shadow-sm text-indigo-500 shrink-0">
                    <Lightbulb size={20} />
                </div>
                <div>
                    {title && <h4 className="font-bold text-indigo-900 text-sm mb-1">{title}</h4>}
                    <div className="text-indigo-800 text-sm leading-relaxed">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};
